__turbopack_context__.v({
  "borderBottom": "styles-module__3kAseq__borderBottom",
  "container": "styles-module__3kAseq__container",
  "description": "styles-module__3kAseq__description",
  "heading": "styles-module__3kAseq__heading",
  "hidden": "styles-module__3kAseq__hidden",
  "marginBottom": "styles-module__3kAseq__marginBottom",
  "titleRow": "styles-module__3kAseq__titleRow",
});
